import { ApiError, apiFetch, parseErrorDetail } from "@/api/fetch";
import type { WorkflowCatalog, WorkflowDetail } from "../types";

const getJson = async <T>(path: string): Promise<T> => {
  const response = await apiFetch(path);
  if (!response.ok) {
    throw new ApiError(await parseErrorDetail(response), response.status);
  }
  return response.json() as Promise<T>;
};

export const getWorkflowCatalog = (): Promise<WorkflowCatalog> =>
  getJson<WorkflowCatalog>("/workflows");

export const getWorkflow = (name: string): Promise<WorkflowDetail> =>
  getJson<WorkflowDetail>(`/workflows/${encodeURIComponent(name)}`);
